import React from "react";
import { Gauge, Plus, Trash2, ShieldCheck, Check, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GrowInput } from "@/components/ui/grow-input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export function ActivityKpisCard({ items, onChange }) {
  const update = (i, field, val) => {
    const next = [...items];
    next[i] = { ...next[i], [field]: val };
    onChange(next);
  };
  return (
    <div className="glass rounded-2xl p-6 border border-border" data-testid="goals-activity-kpis">
      <div className="flex items-center justify-between mb-3">
        <Label className="font-bold flex items-center gap-2"><Gauge className="w-4 h-4 text-primary" /> مؤشرات الأداء التنفيذية — ما نتحكم به أسبوعياً</Label>
        {items.length < 3 && (
          <Button type="button" size="sm" variant="outline" onClick={() => onChange([...items, { label: "", target: 0, unit: "" }])} className="gap-1" data-testid="akpi-add-btn"><Plus className="w-3.5 h-3.5" /> مؤشر</Button>
        )}
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        {items.map((k, i) => (
          <div key={i} className="rounded-xl border border-border bg-secondary/50 p-3 space-y-2" data-testid={`akpi-card-${i}`}>
            <div className="flex items-center gap-1">
              <GrowInput value={k.label} onChange={(e) => update(i, "label", e.target.value)} placeholder="مثال: منشورات أسبوعية" className="bg-background border-border text-sm" data-testid={`akpi-label-${i}`} />
              <Button type="button" size="icon" variant="ghost" onClick={() => onChange(items.filter((_, idx) => idx !== i))} className="text-muted-foreground hover:text-destructive shrink-0 h-8 w-8" data-testid={`akpi-remove-${i}`}><Trash2 className="w-3.5 h-3.5" /></Button>
            </div>
            <div className="flex gap-2">
              <Input type="number" dir="ltr" value={k.target} onChange={(e) => update(i, "target", e.target.value)} className="bg-background border-border font-bold w-24" data-testid={`akpi-target-${i}`} />
              <GrowInput value={k.unit} onChange={(e) => update(i, "unit", e.target.value)} placeholder="الوحدة" className="bg-background border-border text-sm" data-testid={`akpi-unit-${i}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ApproveGoalsButton({ approved, saving, dirty, onApprove, onSaveDraft }) {
  if (approved && !dirty) {
    return (
      <Button disabled className="bg-emerald-600 text-white gap-2 opacity-100" data-testid="save-goals-btn">
        <ShieldCheck className="w-4 h-4" /> الأهداف معتمدة
      </Button>
    );
  }
  return (
    <div className="flex flex-wrap gap-2">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button disabled={saving} className="bg-primary hover:bg-primary/90 text-white gap-2" data-testid="save-goals-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} مراجعة واعتماد الأهداف
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent data-testid="approve-goals-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>اعتماد الأهداف والانتقال للتنفيذ</AlertDialogTitle>
            <AlertDialogDescription className="leading-relaxed">
              باعتمادك تصبح هذه الأهداف (OKR) ومؤشرات الأداء (KPI) مع استراتيجيتك <b>مدخلاً أساسياً لصناعة المحتوى وتجهيز الحملات</b>؛
              كل منشور ودعوة لاتخاذ إجراء يُبنى ليخدم نتيجة رئيسية أو مؤشراً منها وفق أفضل الممارسات. يمكنك تعديلها لاحقاً وإعادة الاعتماد.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="approve-goals-cancel">رجوع للمراجعة</AlertDialogCancel>
            <AlertDialogAction onClick={onApprove} className="bg-primary text-white gap-2" data-testid="approve-goals-confirm"><Check className="w-4 h-4" /> اعتماد والانتقال للتنفيذ</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <Button variant="outline" disabled={saving} onClick={onSaveDraft} className="gap-2" data-testid="save-goals-draft-btn">حفظ كمسودة</Button>
    </div>
  );
}
